import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M30.152 5.333H1.863C2.666 3.858 4.05 2.12 6.343 1.23 8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 2.275.884 3.655 2.602 4.461 4.07",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M1.863 5.333h28.289c.77 1.402 1.015 2.576 1.015 2.576.22.916.39 1.84.516 2.758H.34c.131-.925.305-1.86.526-2.792 0 0 .242-1.155.997-2.542",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.253 1.838.335 3.651.314 5.333H.003v-.017c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016a35 35 0 0 1-.337 5.317H.325A35 35 0 0 1 .003 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 21.333a5.333 5.333 0 1 0 0-10.666 5.333 5.333 0 0 0 0 10.666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-.241 1.155-.997 2.543H1.863c-.755-1.388-.997-2.543-.997-2.543-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.863 26.667h28.274c-.804 1.475-2.188 3.213-4.48 4.103-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23-2.292-.89-3.676-2.628-4.479-4.103",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M17.363 20.425c-.196-.305-.827-.27-.827-.27s-.196-1.426-.043-1.496.605-.017.605-.017c.086 0 .233-.223.116-.364-.116-.14-.051-1.256.31-1.116.86.11 1.508 1.139.54 2.306.021.49.493.537.59.47 2.816-1.967.465-3.866-.14-3.65-.84-1.493-2.514-1.392-2.514-1.392s-.383-.973.058-1.454c.533-.423.478-.88.46-.875a.6.6 0 0 0-.136-.28c-.072-.085.745-.508.416-1.005-.305-.46-1.518-.4-1.683-.135-.118.189.448.858.308.918-.073.032-.492 0-.327.59-.165.155-.753.34-.784.47-.03.129.925.083.925.083l-.14.486s-2.854 2.277 1.022 3.855c0 0 .092.722.006.863-.116-.035-1.304-.076-1.482-.012-.16.047-.772.018-.619.975.117-.259.521-.23.613-.17.092.058.092-.646.6-.587.509.058.876.04.876.04s.172 1.38.117 1.509c-.368-.083-1.244.035-1.299.246.515-.03.337.382.466.587 0 0 .667-.733 1.966-.575",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagUga = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagUga_default = SvgFlagUga;

export { FlagUga_default as default };
